











































































































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";
import Context from "@/mixins/context";
import BrandCurrencyId from "@/mixins/brandCurrencyId";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Components
import { UpmDac } from "@upmind-widgets/dac";

// Types
import {
  IBasketProvisioningFieldsForm,
  IBlueprintField
} from "@/models/provisioning";
import { IBasket } from "@/models/baskets";
import { ICurrency } from "@/models/constants";
import { IClient } from "@/models/clients";
import { BasketTypes } from "@/data/constants";

@Component({
  components: {
    "upm-dac": UpmDac
  }
})
export default class SmartDomainField extends Mixins(
  HasValidation,
  Context,
  BrandCurrencyId
) {
  // Refs

  public declare $refs: {
    domainNameField: HTMLFormElement;
    observer: InstanceType<typeof ValidationObserver>;
  };

  // Props

  @Prop({ required: true })
  public value!: IBasketProvisioningFieldsForm["provision_field_values"];

  @Prop({ required: true })
  public isDisabled!: boolean;

  @Prop({ required: true })
  public field!: IBlueprintField;

  @Prop({ required: true })
  public basketId!: IBasket["id"];

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ default: () => [] })
  public coupons!: string[];

  @Prop({ default: () => vm => vm.brandCurrencyId as ICurrency["id"] })
  public currencyId!: ICurrency["id"];

  @Prop({ required: true })
  public pricesMessage!: string;

  @Prop({ default: "" })
  public label!: string;

  @Prop({ required: true })
  public vname!: string;

  @Prop({ required: true })
  public vid!: string;

  @Prop({ default: "" })
  public rules!: string;

  // Variables

  public dacIsAvailable = false;
  public isLoading = true;
  public isReadonly = false;
  public isKnownRegistration = false;
  public isKnownTransfer = false;

  public showDacWidget = true;
  public newDacProduct = null;
  public selectedDomain:
    | IBasketProvisioningFieldsForm["provision_field_values"]
    | string
    | null = null;
  public isLoadingDomains = false;
  public clientDomains: any[] | null = null;

  // Form

  public get formField() {
    return this.value;
  }

  public set formField(value) {
    this.$emit("input", value);
  }

  public created() {
    this.initSmartField();
  }

  // Methods

  public async initSmartField() {
    try {
      this.isLoading = true;
      this.dacIsAvailable = await this.$store.dispatch(
        `data/${DataModules.HOST_MODULE}/getDacAvailability`,
        {
          params: {
            no_cache: true,
            ...(this.basketId !== BasketTypes.NEW
              ? { order_id: this.basketId }
              : { currency_id: this.currencyId })
          }
        }
      );
    } finally {
      if (this.value) this.isReadonly = true;

      this.showDacWidget = this.dacIsAvailable;
      this.isLoading = false;
    }
  }

  public async addToBasket({ _product, sld = "" }) {
    this.$emit("input", `${sld}${_product.tld}`);

    _product.prices = _.orderBy(_product.prices, ["billing_cycle_months"]);
    _product.options = _.map(_product.options, option => {
      option.prices = _.orderBy(option.prices, ["billing_cycle_months"]);
      return option;
    });

    this.newDacProduct = _product;
    this.isReadonly = true;
    this.isKnownRegistration = _product.domain_available;
    this.isKnownTransfer = !_product.domain_available;

    this.$bus.$emit("basketUpdateCombinedProduct", {
      product: _product,
      sld,
      fieldName: this.field.name
    });
  }

  public toggleReadonly(value) {
    this.isReadonly = value;
    if (!this.isReadonly) {
      this.$emit("input", null);
      this.newDacProduct = null;
      this.$bus.$emit("basketUpdateCombinedProduct", null);
      this.isKnownRegistration = false;
      this.isKnownTransfer = false;
    }
  }

  public getClientDomains() {
    return this.$store.dispatch(
      `data/${DataModules.HOST_MODULE}/getClientDomains`,
      {
        vm: this,
        params: {
          ...(this.basketId !== "new" ? { basket_id: this.basketId } : {}),
          client_id: this.clientId
        },
        storeData: false
      }
    );
  }

  public changeSelectedDomain(value) {
    this.$emit("input", value === "new" ? null : value);

    if (value === "new") {
      this.$nextTick(() => {
        this.$refs.domainNameField.focus();
      });
    }
  }

  // Computed

  public get authToken() {
    return _.get(
      this.$store,
      `state.auth.${this.context}.token.access_token`,
      ""
    );
  }

  public get availableDomains() {
    return this.clientDomains || [];
  }

  public get message() {
    return {
      type: this.isKnownRegistration ? "is-success" : "is-info",
      path: this.isKnownRegistration
        ? "_modules.web_hosting.domains.domain_to_register"
        : this.isKnownTransfer
        ? "_modules.web_hosting.domains.domain_to_transfer"
        : "_modules.web_hosting.domains.selected_domain"
    };
  }

  // Watchers

  @Watch("showDacWidget")
  public async onDacDomainViewChange() {
    if (this.showDacWidget || !this.clientId || !_.isNull(this.clientDomains))
      return;

    try {
      this.isLoadingDomains = true;
      this.clientDomains = await this.getClientDomains();
      this.selectedDomain = _.some(this.clientDomains, [
        "domain_name",
        this.value
      ])
        ? this.value
        : null;
    } catch (error) {
      // Silently catch error
    } finally {
      this.isLoadingDomains = false;
    }
  }
}
